import type { UseFetchOptions } from 'nuxt/app'
import type { $Fetch } from 'ofetch'
export function useAPI<T>(url: string | (() => string), fetchOptions: UseFetchOptions<T> = {}) {
	return useFetch(url, {
		...fetchOptions,
		watch: false,
		timeout: 120000,
		retryDelay: 1000,
		dedupe: 'defer',
		$fetch: useNuxtApp().$api as $Fetch
	})
}
